
export const SET_TRABALHADOR = 'BACKUP_TRABALHADOR';